import TextCreate from 'core/display/simple/Text'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'

export default class FreeBetWinText extends TextCreate{
  constructor(data) {
    super(data)

    this.freeBetModel = game.models.FreebetsModel.get()
    this.freeBetText = this.text._text

    signal.on('FREEBET:END', () => {
      super.update(this.freeBetText.replace('$', FormatService.currency(this.freeBetModel.win)))
      signal.dispatch(`FREEBET:TOTAL-WIN:${this.chooseTypeofWin(game.models.FreebetsModel.get().betValue)}`)
    })
  }

  chooseTypeofWin(bet) {
    if (this.freeBetModel.win / bet >= 50) {
      return 'mega'
    }
    else if (this.freeBetModel.win / bet >= 10) {
      return 'ultra'
    }
    else if (this.freeBetModel.win / bet >= 5){
      return 'big'
    }
    else {
      return 'total'
    }
  }
}
